goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_left_svg");
goog.provide("module$shadow_js_shim_module$src$svg$arrows$arrow_left_svg");
shadow.js.shim.module$src$svg$arrows$arrow_left_svg = shadow.js.nativeProvides["src/svg/arrows/arrow-left.svg"] = shadow$bridge("src/svg/arrows/arrow-left.svg");
module$shadow_js_shim_module$src$svg$arrows$arrow_left_svg.default = shadow.js.shim.module$src$svg$arrows$arrow_left_svg;
